import React from 'react';
import { Row, Col, Pagination, Button, Tooltip, Empty } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Loading from '../../../shared/components/Loading/Index';

export default function Items(props) {
    return (
        <Loading visible={props.pagination.loading} text='Un momento por favor.'>
            <Row style={{ minHeight: '250px', margin: '0px -10px 0px -10px' }}>
                {
                    props.pagination.items.length === 0 ?
                        <div className='vertical-center horizontal-center'>
                            <Empty description='No se encontraron datos' />
                        </div> :
                        props.pagination.items.map(item => (
                            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} key={item.id} >
                                <div
                                    className="content-card content-card-category"
                                    id={item.id}
                                    draggable={true}
                                    onDragOver={(ev) => ev.preventDefault()}
                                    onDragStart={props.onDragStart}
                                    onDragEnter={props.onDragEnter}
                                    onDragLeave={props.onDragLeave}
                                    onDrop={props.onDrop}
                                    onDragEnd={props.onDragEnd}
                                >
                                    <div className='catalog-card-content'>
                                        <div className='catalog-card-item' style={{ pointerEvents: 'none' }}>
                                            <div className="vertical-center h-100">
                                                <img src={item.imageMedium ?? item.imageUrl} alt="card" />
                                            </div>
                                        </div>
                                        <div className='catalog-card-info'>
                                            <div className="flex-parent">
                                                <div className="flex-child long-and-truncated">
                                                    <div className='ml-5'>
                                                        {
                                                            [undefined, '', null].includes(item.name) ?
                                                                <p style={{ color: '#d4d4d4' }}>Sin título</p> :
                                                                <div className='catalog-card-title'>{item.name}</div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="flex-child short-and-fixed">
                                                    <Tooltip title='Eliminar'>
                                                        <Button danger
                                                            type="text"
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => props.onDelete(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title='Modificar'>
                                                        <Button
                                                            type="text"
                                                            onClick={() => props.onEdit(item)}
                                                            icon={<EditOutlined />}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))
                }
            </Row>
            <Row justify='end'>
                <Pagination
                    className='mt-10'
                    size='small'
                    defaultCurrent={1}
                    total={props.pagination.total}
                    current={props.pagination.page}
                    showSizeChanger={false}
                    responsive={true}
                    pageSize={props.pagination.size}
                    onChange={(page, size) => props.onPagination({ ...props.pagination, page, size })}
                    showTotal={(total) => `${total} Registro(s) encontrado(s).`}
                />
            </Row>
        </Loading>
    );
};
